var _defs, _path, _ellipse, _g, _g2, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _path5, _g3, _g4, _rect, _path6, _g5, _path7, _g6, _g7, _g8, _path8, _circle5, _g9, _g10, _g11, _path9, _g12, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g13, _g14, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g15, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g16, _g17, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogInMobileFooterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 280,
    height: 204.263,
    viewBox: "0 0 280 204.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_339",
    "data-name": "Ellipse 339",
    cx: 76.393,
    cy: 82.459,
    rx: 76.393,
    ry: 82.459,
    transform: "translate(0 152.64) rotate(-87.486)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4931",
    "data-name": "Path 4931",
    d: "M1433.377,348.584a1.548,1.548,0,0,1-1.521,1.4l-83.124.636a1.491,1.491,0,0,1-1.5-1.373l-3.534-58.738a1.509,1.509,0,0,1,1.445-1.666l90.96-.967a1.463,1.463,0,0,1,1.441,1.643Z",
    transform: "translate(-1343.699 -287.879)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2425",
    "data-name": "Rectangle 2425",
    width: 59.165,
    height: 38.193,
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -26.083,
    y1: 158.797,
    x2: -20.766,
    y2: 127.175,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2337",
    "data-name": "Group 2337",
    transform: "translate(-30 -657.539)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    d: "M437.765,99.068c17.918,16.5,71.414-9.489,74.324,24.066,3.407,39.29-50.035,56.531-29.464,82.249s4.255,58.653-66.912,65.491S226.548,255.053,250.186,214.6s5.075-40.461,2-56.926,7.064-54.345,65.3-29.715S392.392,57.3,437.765,99.068Z",
    transform: "translate(-217.107 569.207)",
    fill: "#f4f6f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247",
    transform: "translate(80.02 683.951)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_337",
    "data-name": "Ellipse 337",
    cx: 76.393,
    cy: 82.459,
    rx: 76.393,
    ry: 82.459,
    transform: "matrix(0.044, -0.999, 0.999, 0.044, 0, 152.64)",
    fill: "#b8c2cb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2245",
    "data-name": "Group 2245",
    transform: "translate(16.562 13.299)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_338",
    "data-name": "Ellipse 338",
    cx: 64.705,
    cy: 61.125,
    rx: 64.705,
    ry: 61.125,
    fill: "#dbe3eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2246",
    "data-name": "Group 2246",
    transform: "translate(10.722 5.501)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    d: "M1112.364,395.011c-.006,6.741-.254,13.482-.777,20.2s-1.359,13.422-2.551,20.062c-.6,3.319-1.3,6.622-2.134,9.893a95.363,95.363,0,0,1-2.978,9.682,45.932,45.932,0,0,1-4.442,9.129,18.268,18.268,0,0,1-3.336,3.887,9.51,9.51,0,0,1-2.186,1.408,6.561,6.561,0,0,1-2.556.6,6.452,6.452,0,0,1-2.583-.474,8.937,8.937,0,0,1-2.238-1.33,17.33,17.33,0,0,1-3.408-3.827,44.435,44.435,0,0,1-4.506-9.1,93.147,93.147,0,0,1-3.009-9.673c-.84-3.27-1.546-6.571-2.154-9.888-1.213-6.637-2.041-13.337-2.6-20.056s-.836-13.462-.873-20.2c-.018-3.371.079-6.741.2-10.109s.316-6.734.566-10.1c.5-6.722,1.252-13.428,2.363-20.079.558-3.325,1.208-6.636,1.989-9.917a95.459,95.459,0,0,1,2.821-9.719,44.034,44.034,0,0,1,4.318-9.161,16.651,16.651,0,0,1,3.333-3.848,8.513,8.513,0,0,1,2.2-1.319,6.222,6.222,0,0,1,2.536-.449,6.729,6.729,0,0,1,2.505.586,9.784,9.784,0,0,1,2.176,1.356,18.558,18.558,0,0,1,3.4,3.781,45.519,45.519,0,0,1,4.667,8.987,92.166,92.166,0,0,1,3.2,9.6c.9,3.251,1.665,6.539,2.327,9.845a191.278,191.278,0,0,1,2.829,20.022C1112.06,381.527,1112.347,388.269,1112.364,395.011Zm-1.117,0q.021-10.068-.8-20.115a194.078,194.078,0,0,0-2.613-19.954c-.618-3.3-1.337-6.576-2.194-9.819a91.5,91.5,0,0,0-3.062-9.574,45.021,45.021,0,0,0-4.5-8.942,18.149,18.149,0,0,0-3.279-3.737,9.437,9.437,0,0,0-2.077-1.331,6.2,6.2,0,0,0-2.37-.579,5.818,5.818,0,0,0-2.391.452,8.139,8.139,0,0,0-2.092,1.288,16.238,16.238,0,0,0-3.2,3.791,43.5,43.5,0,0,0-4.154,9.106,94.584,94.584,0,0,0-2.684,9.688c-.737,3.272-1.343,6.574-1.858,9.891a259.431,259.431,0,0,0-2.66,40.151q-.032,10.067.7,20.119c.5,6.692,1.267,13.368,2.416,19.978.576,3.3,1.249,6.592,2.056,9.845a92.558,92.558,0,0,0,2.9,9.615,43.767,43.767,0,0,0,4.352,8.987,16.7,16.7,0,0,0,3.244,3.711,8.325,8.325,0,0,0,2.072,1.258,5.7,5.7,0,0,0,2.34.446,5.953,5.953,0,0,0,2.317-.568,8.891,8.891,0,0,0,2.029-1.335,17.612,17.612,0,0,0,3.178-3.776,45.228,45.228,0,0,0,4.287-9.021,94.437,94.437,0,0,0,2.866-9.625c.8-3.256,1.463-6.545,2.033-9.85,1.142-6.611,1.9-13.288,2.4-19.98S1111.251,401.725,1111.248,395.011Z",
    transform: "translate(-1016.231 -320.207)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    d: "M909.207,392.418a98.284,98.284,0,0,1-3.492,25.741,82.839,82.839,0,0,1-10.782,23.6,62.59,62.59,0,0,1-18.361,18.216,48.821,48.821,0,0,1-11.817,5.4,44.264,44.264,0,0,1-25.693.013A48.834,48.834,0,0,1,827.236,460a62.634,62.634,0,0,1-18.395-18.206,82.986,82.986,0,0,1-10.814-23.61,93.424,93.424,0,0,1-2.619-12.764,95.786,95.786,0,0,1,.009-26,93.324,93.324,0,0,1,2.629-12.76,82.943,82.943,0,0,1,10.83-23.592,62.532,62.532,0,0,1,18.392-18.178,49.054,49.054,0,0,1,11.816-5.368,43.911,43.911,0,0,1,25.648.012,49.009,49.009,0,0,1,11.806,5.378A62.49,62.49,0,0,1,894.9,343.1a82.806,82.806,0,0,1,10.8,23.582A98.279,98.279,0,0,1,909.207,392.418Zm-1.28,0a97.066,97.066,0,0,0-3.335-25.43,82.436,82.436,0,0,0-10.4-23.419,67.16,67.16,0,0,0-8.023-10.036,56.069,56.069,0,0,0-9.928-8.15,47.963,47.963,0,0,0-11.648-5.389,42.7,42.7,0,0,0-25.362.012,47.925,47.925,0,0,0-11.637,5.4,56.013,56.013,0,0,0-9.912,8.157,67.128,67.128,0,0,0-8.005,10.038,82.3,82.3,0,0,0-10.368,23.41,94.132,94.132,0,0,0-2.491,12.595,98.151,98.151,0,0,0,.009,25.624,94.046,94.046,0,0,0,2.5,12.591,82.261,82.261,0,0,0,10.384,23.391,67.081,67.081,0,0,0,8.006,10.026,55.8,55.8,0,0,0,9.909,8.14,48.144,48.144,0,0,0,11.627,5.377,42.362,42.362,0,0,0,25.317.013,48.157,48.157,0,0,0,11.637-5.367,55.864,55.864,0,0,0,9.924-8.134,67.119,67.119,0,0,0,8.024-10.023,82.412,82.412,0,0,0,10.416-23.4A97.058,97.058,0,0,0,907.927,392.418Z",
    transform: "translate(-779.075 -317.614)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4761",
    "data-name": "Path 4761",
    d: "M726.5,640.276l17.186-.155,17.186-.088c5.729-.038,11.457-.034,17.186-.045l17.186-.026,34.372.078,17.186.1,17.186.168a.057.057,0,0,1,0,.113l-17.186.168-17.186.1-34.372.078-17.186-.026c-5.729-.012-11.457-.007-17.186-.045l-17.186-.088-17.186-.155a.084.084,0,0,1,0-.168Z",
    transform: "translate(-720.447 -595.094)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4762",
    "data-name": "Path 4762",
    d: "M869.752,433.468c4.067-.072,8.134-.1,12.2-.155l12.2-.088c4.067-.038,8.134-.034,12.2-.045l12.2-.026,12.2.03c4.067.018,8.134.008,12.2.049l12.2.1c4.067.057,8.134.091,12.2.168a.056.056,0,0,1,0,.113c-4.067.077-8.134.111-12.2.168l-12.2.1c-4.067.04-8.134.031-12.2.049l-12.2.029-12.2-.026c-4.067-.012-8.134-.008-12.2-.045l-12.2-.088c-4.067-.052-8.135-.083-12.2-.155a.084.084,0,0,1,0-.168Z",
    transform: "translate(-843.758 -417.071)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4763",
    "data-name": "Path 4763",
    d: "M683.594,847.086l18.679-.156,18.679-.088,37.359-.071,37.358.078,18.679.1,18.679.168a.057.057,0,0,1,0,.113l-18.679.168-18.679.1-37.358.078-37.359-.071-18.679-.088-18.679-.156a.084.084,0,0,1,0-.168Z",
    transform: "translate(-683.51 -773.119)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M726.5,1053.894l17.186-.155,17.186-.088c5.729-.038,11.457-.033,17.186-.045l17.186-.026,34.372.078,17.186.1,17.186.168a.056.056,0,0,1,0,.113l-17.186.168-17.186.1-34.372.078-17.186-.026c-5.729-.012-11.457-.008-17.186-.045l-17.186-.088-17.186-.155a.084.084,0,0,1,0-.169Z",
    transform: "translate(-720.447 -951.142)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4765",
    "data-name": "Path 4765",
    d: "M983.721,1261.723H886.108a.295.295,0,0,1,0-.59h97.614a.295.295,0,1,1,0,.59Z",
    transform: "translate(-857.655 -1129.807)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2249",
    "data-name": "Group 2249",
    transform: "translate(80.02 684.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2248",
    "data-name": "Group 2248",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4766",
    "data-name": "Path 4766",
    d: "M755.42,524.337s-5.874.113-4.179-5.986,1.016-10.166,5.76-11.182,7.455-1.807,4.631-3.614-7.116,1.581-9.6,0,1.017-5.083-2.711-2.6-4.857,7.116-7.342,5.535-2.146-2.485,1.129-4.631,3.953-3.953.339-4.066-20.218.226-26.544,0S664.72,487.4,663.138,484.465s-2.259,2.259-2.824,5.422-.9,3.953-2.937,1.694-4.631-9.149-7.116-2.824,1.017,9.714-1.92,16.265-7.794,17.395,0,25.075a3.037,3.037,0,0,0,.9,4.292c2.6,1.694,1.694-.452,1.355,2.259s-1.807,10.166,2.259,10.73-.339,8.848,6.137,10.354,3.163-5.723,11.9,1.506,15.813,7.379,20.783,4.669,0-3.614,5.723,4.518,7.38,7.379,11.145,4.819,4.669-.6,5.723.9,4.066,12.876,12.124,13.178c3.993.149,3.671-.736,1.71-3.309-2.079-2.728-2.445-5.278,1.528-6.4,5.045-1.431,7.53.6,12.2-4.819s5.12-1.958,8.133,0,4.217.9,4.217-1.506.753-6.325,3.012-4.217.753,2.259,4.066,1.807,5.271-3.614,8.885-.6,4.518,5.422,9.338,12.2c1.491,2.1,3.89,4.556,6.362,2.538,5.579-4.554-2.119-10.7-4.452-14.269-2.185-3.345-2.333-6.406-1.01-10.149a19.278,19.278,0,0,1,1.99-4.891c1.893-2.672,5.453-3.366,7.531-5.883,2.343-2.838,1.967-6.2.422-9.365-3.012-6.175-4.669-12.2-2.259-11.446s5.723,8.283,6.928,4.819,1.054-15.813,6.627-16.566,3.012-2.56,3.916-4.066-3.313,1.657-4.066-2.259-1.054-6.928,2.711-6.928,7.078-1.2,4.368-4.669-8.434-12.349-11.3-7.681,3.012,10.843-2.26,12.35c-3.3.944-14.218,4.395-13.055,9.274.343,1.438,1.918,1.643.355,2.623-1.311.822-4.233.2-5.917,1.083-3.578,1.871-2.5,4.478-4.3,7.41-1.094,1.772-5.431,4.456-5.234,1.006.073-1.273,4.2-7.091,1.648-7.992s-2.259,1.506-3.917.752c-2.369-1.083.253-7.684-3.5-7.628-2.211.033-4.268,4.819-4.2,6.695C756.98,518.42,760.372,523.319,755.42,524.337Z",
    transform: "translate(-638.889 -455.394)",
    fill: "#d1d8df"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 3.567,
    cy: 3.567,
    r: 3.567,
    transform: "matrix(0.23, -0.973, 0.973, 0.23, 124.758, 770.979)",
    fill: "#b8c2cb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_341",
    "data-name": "Ellipse 341",
    cx: 3.567,
    cy: 3.567,
    r: 3.567,
    transform: "translate(173.161 753.91) rotate(-76.717)",
    fill: "#b8c2cb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_342",
    "data-name": "Ellipse 342",
    cx: 3.567,
    cy: 3.567,
    r: 3.567,
    transform: "translate(144.385 738.776) rotate(-45)",
    fill: "#b8c2cb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_343",
    "data-name": "Ellipse 343",
    cx: 3.567,
    cy: 3.567,
    r: 3.567,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 175.143, 790.383)",
    fill: "#b8c2cb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4767",
    "data-name": "Path 4767",
    d: "M1006.433,832.527a26.129,26.129,0,0,1-15.8-5.418l.31-.4a25.352,25.352,0,0,0,19.074,5.044,26.871,26.871,0,0,0,17.161-10.555,25.963,25.963,0,0,0,4.116-7.932l.487.15a26.481,26.481,0,0,1-4.2,8.088,27.382,27.382,0,0,1-17.492,10.752A24.377,24.377,0,0,1,1006.433,832.527Z",
    transform: "translate(-857.144 -54.82)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4768",
    "data-name": "Path 4768",
    d: "M1342.777,802.449a12.07,12.07,0,0,1-7.434-2.241c-5.016-3.756-5.074-11.018-5.074-11.091h.509c0,.07.061,7.085,4.873,10.685,3.264,2.442,7.942,2.793,13.907,1.044l.144.489A24.819,24.819,0,0,1,1342.777,802.449Z",
    transform: "translate(-1149.507 -34.037)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4769",
    "data-name": "Path 4769",
    d: "M1003.863,723.173a1.161,1.161,0,0,1-.944-.417l.4-.321c.446.551,1.535-.052,1.749-.179a31.744,31.744,0,0,0,11.106-10.691,23.521,23.521,0,0,0,3.412-14.859l.506-.061a24.03,24.03,0,0,1-3.481,15.183,32.249,32.249,0,0,1-11.283,10.866A2.973,2.973,0,0,1,1003.863,723.173Z",
    transform: "translate(-867.72 45.563)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    d: "M1345.666,899.782l-.478-.176a12.4,12.4,0,0,1,3.064-4.275,50.777,50.777,0,0,1,10.712-8.211,14.815,14.815,0,0,1,4.888-1.973l.083.5a14.375,14.375,0,0,0-4.717,1.912,50.244,50.244,0,0,0-10.6,8.129A11.94,11.94,0,0,0,1345.666,899.782Z",
    transform: "translate(-1162.347 -116.701)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255",
    transform: "translate(201.071 761.444)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_344",
    "data-name": "Ellipse 344",
    cx: 3.633,
    cy: 3.633,
    r: 3.633,
    transform: "translate(0 2.78) rotate(-22.5)",
    fill: "#b8c2cb"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2259",
    "data-name": "Group 2259",
    transform: "translate(96.135 830.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258",
    transform: "translate(0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4773",
    "data-name": "Path 4773",
    d: "M737.333,1328.35h-5.875c-1.546,0-2.961.891-2.961,2.438v3.349h1.592v-3.349a1.292,1.292,0,0,1,1.369-1.281h5.875a1.228,1.228,0,0,1,1.292,1.281v3.349h1.592v-3.349C740.217,1329.241,738.879,1328.35,737.333,1328.35Z",
    transform: "translate(-728.497 -1328.35)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4774",
    "data-name": "Path 4774",
    d: "M725.732,1361.052v.023c0,.338-.3.8-.612.8h-2.247c-.314,0-.614-.463-.614-.8v-.023c0-.338.3-.478.614-.478h2.247C725.435,1360.574,725.732,1360.714,725.732,1361.052Z",
    transform: "translate(-722.26 -1356.089)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4775",
    "data-name": "Path 4775",
    d: "M799.249,1361.052v.023c0,.338-.223.8-.537.8h-2.247c-.314,0-.4-.463-.4-.8v-.023c0-.338.085-.478.4-.478h2.247C799.026,1360.574,799.249,1360.714,799.249,1361.052Z",
    transform: "translate(-785.793 -1356.089)",
    fill: "#d1d8df"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2420",
    "data-name": "Rectangle 2420",
    width: 34.581,
    height: 24.453,
    rx: 12.226,
    transform: "translate(85.139 835.199)",
    fill: "#dbe3eb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4776",
    "data-name": "Path 4776",
    d: "M683.455,1376.054a3.747,3.747,0,0,0-3.867-3.65H654.833a3.748,3.748,0,0,0-3.867,3.65v14.552a3.784,3.784,0,0,0,3.867,3.695h24.756a3.784,3.784,0,0,0,3.867-3.695Z",
    transform: "translate(-564.754 -536.138)",
    fill: "#dbe3eb"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267",
    transform: "translate(89.045 834.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M682.967,1382.437a1.223,1.223,0,0,1-1.088,1.207h-1.157a1.218,1.218,0,0,1-1.083-1.207v-23.994a1.024,1.024,0,0,1,1.083-.988h1.157a1.029,1.029,0,0,1,1.088.988Z",
    transform: "translate(-678.482 -1357.455)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2260",
    "data-name": "Group 2260",
    transform: "translate(0 4.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M675.4,1393.877h-2.384a1.929,1.929,0,0,1-1.693-1.7v-1.469c0-.726.827-1.026,1.693-1.026H675.4c.818,0,1.421.276,1.421,1.026v1.469A1.694,1.694,0,0,1,675.4,1393.877Zm-2.384-3.617c-.452,0-.825.131-.825.447v1.469c0,.321.364.544.825.544H675.4c.432,0,.7-.2.7-.544v-1.469c0-.354-.272-.447-.7-.447Z",
    transform: "translate(-671.323 -1389.681)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2261",
    "data-name": "Group 2261",
    transform: "translate(1.592 6.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2421",
    "data-name": "Rectangle 2421",
    width: 0.723,
    height: 2.46,
    rx: 0.362,
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2422",
    "data-name": "Rectangle 2422",
    width: 0.723,
    height: 2.46,
    rx: 0.362,
    transform: "translate(1.736)",
    fill: "#d1d8df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266",
    transform: "translate(21.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4779",
    "data-name": "Path 4779",
    d: "M835.633,1382.437a1.172,1.172,0,0,1-1.028,1.207h-1.157a1.149,1.149,0,0,1-1-1.207v-23.994a.952.952,0,0,1,1-.988h1.157a.977.977,0,0,1,1.028.988Z",
    transform: "translate(-831.148 -1357.455)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264",
    transform: "translate(0 4.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4780",
    "data-name": "Path 4780",
    d: "M827.232,1393.877h-2.384a1.991,1.991,0,0,1-1.754-1.7v-1.469c0-.726.887-1.026,1.754-1.026h2.384c.818,0,1.36.276,1.36,1.026v1.469C828.592,1392.959,828.01,1393.877,827.232,1393.877Zm-2.384-3.617c-.451,0-.885.131-.885.447v1.469c0,.321.424.544.885.544h2.384c.432,0,.926-.2.926-.544v-1.469c0-.354-.5-.447-.926-.447Z",
    transform: "translate(-823.094 -1389.681)",
    fill: "#d1d8df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265",
    transform: "translate(1.881 6.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2423",
    "data-name": "Rectangle 2423",
    width: 0.723,
    height: 2.46,
    rx: 0.362,
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2424",
    "data-name": "Rectangle 2424",
    width: 0.723,
    height: 2.46,
    rx: 0.362,
    transform: "translate(1.447)",
    fill: "#d1d8df"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268",
    transform: "translate(85.862 852.6)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4781",
    "data-name": "Path 4781",
    d: "M650.483,1495.226c-.019,0,.008,0-.011-.013a3.614,3.614,0,0,1-2.019-3.308v-2.018a.145.145,0,0,1,.289,0v2.018a3.339,3.339,0,0,0,1.858,3.068c.066.032.064.113.032.179A.183.183,0,0,1,650.483,1495.226Z",
    transform: "translate(-648.453 -1489.753)",
    fill: "#7d97f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    transform: "translate(118.852 841.029)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2269",
    "data-name": "Group 2269",
    transform: "translate(0 5.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4782",
    "data-name": "Path 4782",
    d: "M885.611,1454.1a.143.143,0,0,1-.145-.133V1446.4a.145.145,0,0,1,.29,0v7.566A.143.143,0,0,1,885.611,1454.1Z",
    transform: "translate(-885.466 -1446.267)",
    fill: "#7d97f4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    "data-name": "Group 2270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4783",
    "data-name": "Path 4783",
    d: "M885.611,1410.356a.144.144,0,0,1-.145-.134v-3.471a.145.145,0,0,1,.29,0v3.471A.144.144,0,0,1,885.611,1410.356Z",
    transform: "translate(-885.466 -1406.617)",
    fill: "#7d97f4"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273",
    transform: "translate(178.618 681.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4784",
    "data-name": "Path 4784",
    d: "M1323.922,329.445a5.522,5.522,0,0,1-5.517-5.171l-3.534-58.738a5.688,5.688,0,0,1,1.495-4.207,5.416,5.416,0,0,1,3.94-1.742l91.019-.967a5.453,5.453,0,0,1,3.978,1.728,5.645,5.645,0,0,1,1.478,4.24l-4.172,59.063a5.591,5.591,0,0,1-5.521,5.158Z",
    transform: "translate(-1314.861 -258.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4785",
    "data-name": "Path 4785",
    d: "M1456.713,754.637l6.522,15.015a.666.666,0,0,0,1.264-.132l3.042-14.87Z",
    transform: "translate(-1436.969 -685.597)",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4786",
    "data-name": "Path 4786",
    d: "M1433.569,348.357a1.548,1.548,0,0,1-1.521,1.4l-83.124.636a1.49,1.49,0,0,1-1.495-1.373l-3.534-58.738a1.509,1.509,0,0,1,1.445-1.666l90.961-.967a1.463,1.463,0,0,1,1.44,1.643l-2.048,29Z",
    transform: "translate(-1161.232 397.63)",
    fill: "#f4f6f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2320",
    "data-name": "Group 2320",
    transform: "translate(182.632 685.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316",
    transform: "translate(49.646 3.274)"
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_345",
    "data-name": "Ellipse 345",
    cx: 2.565,
    cy: 2.565,
    r: 2.565,
    transform: "translate(42.809 23.513)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(0 22.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310",
    transform: "translate(0.477 3.553)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2285",
    "data-name": "Group 2285",
    transform: "translate(11.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4787",
    "data-name": "Path 4787",
    d: "M1801.094,497.831a.775.775,0,0,0-.764-.764h-15.738a.847.847,0,0,0-.836.788v37.974a.832.832,0,0,0,.82.769l16.454-.045a.771.771,0,0,0,.549-.231.783.783,0,0,0,.22-.557Z",
    transform: "translate(-1783.756 -497.067)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284",
    transform: "translate(1.229 2.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4788",
    "data-name": "Path 4788",
    d: "M1797.106,514.868l-4.484-.006-.036-2.314h4.488Z",
    transform: "translate(-1792.586 -512.548)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4789",
    "data-name": "Path 4789",
    d: "M1833.267,514.867l-4.479-.006-.031-2.313h4.484Z",
    transform: "translate(-1823.723 -512.548)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4790",
    "data-name": "Path 4790",
    d: "M1869.393,514.866l-4.474-.006-.026-2.311h4.479Z",
    transform: "translate(-1854.828 -512.548)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276",
    transform: "translate(0.064 4.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4791",
    "data-name": "Path 4791",
    d: "M1797.557,544.846l-4.476,0-.035-2.3,4.48,0Z",
    transform: "translate(-1793.046 -542.544)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4792",
    "data-name": "Path 4792",
    d: "M1833.656,544.829l-4.471,0-.03-2.3,4.475,0Z",
    transform: "translate(-1824.129 -542.531)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    "data-name": "Group 2275",
    transform: "translate(10.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4793",
    "data-name": "Path 4793",
    d: "M1869.719,544.813l-4.467,0-.026-2.3,4.47,0Z",
    transform: "translate(-1865.227 -542.518)",
    fill: "#d1d8df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277",
    transform: "translate(0.128 8.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4794",
    "data-name": "Path 4794",
    d: "M1798.007,574.53l-4.468,0-.035-2.291,4.472,0Z",
    transform: "translate(-1793.504 -572.232)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4795",
    "data-name": "Path 4795",
    d: "M1834.043,574.5l-4.463,0-.031-2.29,4.468,0Z",
    transform: "translate(-1824.532 -572.206)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4796",
    "data-name": "Path 4796",
    d: "M1870.043,574.468l-4.459,0-.026-2.289,4.464,0Z",
    transform: "translate(-1855.529 -572.18)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278",
    transform: "translate(0.191 12.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4797",
    "data-name": "Path 4797",
    d: "M1798.455,604.111l-4.46.007-.035-2.283,4.464-.006Z",
    transform: "translate(-1793.96 -601.816)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4798",
    "data-name": "Path 4798",
    d: "M1834.428,604.065l-4.456.007-.03-2.282,4.459-.006Z",
    transform: "translate(-1824.935 -601.778)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4799",
    "data-name": "Path 4799",
    d: "M1870.367,604.019l-4.451.007-.026-2.281,4.455-.006Z",
    transform: "translate(-1855.878 -601.74)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    "data-name": "Group 2279",
    transform: "translate(0.255 16.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4800",
    "data-name": "Path 4800",
    d: "M1798.9,633.59l-4.452.008-.035-2.275,4.457-.007Z",
    transform: "translate(-1794.415 -631.299)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4801",
    "data-name": "Path 4801",
    d: "M1834.814,633.53l-4.448.008-.03-2.274,4.452-.007Z",
    transform: "translate(-1825.336 -631.249)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4802",
    "data-name": "Path 4802",
    d: "M1870.689,633.469l-4.443.008-.025-2.273,4.448-.007Z",
    transform: "translate(-1856.226 -631.198)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2280",
    "data-name": "Group 2280",
    transform: "translate(0.318 20.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4803",
    "data-name": "Path 4803",
    d: "M1799.348,662.967l-4.445.01-.035-2.267,4.449-.009Z",
    transform: "translate(-1794.869 -660.68)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4804",
    "data-name": "Path 4804",
    d: "M1835.2,662.892l-4.44.01-.03-2.266,4.444-.009Z",
    transform: "translate(-1825.735 -660.617)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4805",
    "data-name": "Path 4805",
    d: "M1871.01,662.817l-4.436.01-.025-2.265,4.44-.009Z",
    transform: "translate(-1856.572 -660.553)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281",
    transform: "translate(0.38 24.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4806",
    "data-name": "Path 4806",
    d: "M1799.792,692.243l-4.437.012L1795.32,690l4.441-.011Z",
    transform: "translate(-1795.32 -689.96)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4807",
    "data-name": "Path 4807",
    d: "M1835.579,692.154l-4.433.012-.03-2.258,4.436-.011Z",
    transform: "translate(-1826.134 -689.884)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4808",
    "data-name": "Path 4808",
    d: "M1871.33,692.064l-4.428.012-.025-2.257,4.432-.011Z",
    transform: "translate(-1856.917 -689.808)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282",
    transform: "translate(0.443 28.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4809",
    "data-name": "Path 4809",
    d: "M1800.233,721.418l-4.429.014-.035-2.252,4.433-.013Z",
    transform: "translate(-1795.769 -719.139)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4810",
    "data-name": "Path 4810",
    d: "M1835.959,721.315l-4.425.014-.03-2.25,4.429-.013Z",
    transform: "translate(-1826.531 -719.051)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4811",
    "data-name": "Path 4811",
    d: "M1871.649,721.211l-4.421.014-.025-2.249,4.424-.013Z",
    transform: "translate(-1857.261 -718.962)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283",
    transform: "translate(0.506 32.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4812",
    "data-name": "Path 4812",
    d: "M1800.674,750.493l-4.421.016-.035-2.244,4.426-.015Z",
    transform: "translate(-1796.218 -748.218)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4813",
    "data-name": "Path 4813",
    d: "M1836.338,750.375l-4.417.015-.03-2.243,4.421-.015Z",
    transform: "translate(-1826.927 -748.117)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4814",
    "data-name": "Path 4814",
    d: "M1871.966,750.257l-4.413.016-.026-2.242,4.417-.015Z",
    transform: "translate(-1857.602 -748.016)",
    fill: "#d1d8df"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2296",
    "data-name": "Group 2296",
    transform: "translate(0 13.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4815",
    "data-name": "Path 4815",
    d: "M1718.158,597.568c-.007-.221-.288-.4-.632-.4H1704.5c-.349,0-.692.192-.692.416v20.042a.4.4,0,0,0,.216.288.9.9,0,0,0,.463.118l13.62-.024a.85.85,0,0,0,.454-.122.353.353,0,0,0,.182-.294Z",
    transform: "translate(-1703.806 -597.165)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2295",
    "data-name": "Group 2295",
    transform: "translate(1.017 1.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2286",
    "data-name": "Group 2286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4816",
    "data-name": "Path 4816",
    d: "M1714.855,606.56l-3.711,0-.03-1.221h3.715Z",
    transform: "translate(-1711.115 -605.336)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4817",
    "data-name": "Path 4817",
    d: "M1744.789,606.56l-3.708,0-.026-1.221h3.711Z",
    transform: "translate(-1736.888 -605.336)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4818",
    "data-name": "Path 4818",
    d: "M1774.692,606.559l-3.7,0-.022-1.22h3.708Z",
    transform: "translate(-1762.636 -605.336)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2287",
    "data-name": "Group 2287",
    transform: "translate(0.053 2.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4819",
    "data-name": "Path 4819",
    d: "M1715.229,622.382h-3.7l-.029-1.213h3.708Z",
    transform: "translate(-1711.495 -621.167)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4820",
    "data-name": "Path 4820",
    d: "M1745.111,622.373h-3.7l-.025-1.212h3.7Z",
    transform: "translate(-1737.224 -621.16)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4821",
    "data-name": "Path 4821",
    d: "M1774.962,622.365l-3.7,0-.021-1.212h3.7Z",
    transform: "translate(-1762.927 -621.153)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288",
    transform: "translate(0.106 4.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4822",
    "data-name": "Path 4822",
    d: "M1715.6,638.048l-3.7,0-.029-1.209,3.7,0Z",
    transform: "translate(-1711.874 -636.835)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4823",
    "data-name": "Path 4823",
    d: "M1745.431,638.032l-3.694,0-.025-1.208,3.7,0Z",
    transform: "translate(-1737.559 -636.822)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4824",
    "data-name": "Path 4824",
    d: "M1775.23,638.016l-3.691,0-.021-1.208,3.695,0Z",
    transform: "translate(-1763.216 -636.809)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289",
    transform: "translate(0.158 6.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4825",
    "data-name": "Path 4825",
    d: "M1715.973,653.661l-3.692,0-.029-1.2,3.7,0Z",
    transform: "translate(-1712.252 -652.45)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4826",
    "data-name": "Path 4826",
    d: "M1745.75,653.637l-3.688,0-.025-1.2,3.691,0Z",
    transform: "translate(-1737.892 -652.43)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4827",
    "data-name": "Path 4827",
    d: "M1775.5,653.613l-3.684,0-.021-1.2,3.688,0Z",
    transform: "translate(-1763.505 -652.41)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290",
    transform: "translate(0.211 8.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4828",
    "data-name": "Path 4828",
    d: "M1716.343,669.219l-3.685,0-.029-1.2,3.689,0Z",
    transform: "translate(-1712.629 -668.01)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4829",
    "data-name": "Path 4829",
    d: "M1746.069,669.187l-3.682,0-.025-1.2,3.685,0Z",
    transform: "translate(-1738.224 -667.984)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4830",
    "data-name": "Path 4830",
    d: "M1775.764,669.155l-3.678,0-.021-1.2,3.682,0Z",
    transform: "translate(-1763.792 -667.957)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291",
    transform: "translate(0.263 10.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4831",
    "data-name": "Path 4831",
    d: "M1716.711,684.724l-3.679.005-.029-1.2,3.682,0Z",
    transform: "translate(-1713.003 -683.517)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4832",
    "data-name": "Path 4832",
    d: "M1746.385,684.684l-3.675.005-.025-1.2,3.679,0Z",
    transform: "translate(-1738.554 -683.484)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4833",
    "data-name": "Path 4833",
    d: "M1776.03,684.645l-3.671.005-.021-1.2,3.675,0Z",
    transform: "translate(-1764.08 -683.45)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292",
    transform: "translate(0.315 13.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4834",
    "data-name": "Path 4834",
    d: "M1717.079,700.175l-3.673.006-.029-1.193,3.676-.006Z",
    transform: "translate(-1713.378 -698.97)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4835",
    "data-name": "Path 4835",
    d: "M1746.7,700.128l-3.669.006-.025-1.192,3.672-.006Z",
    transform: "translate(-1738.884 -698.93)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4836",
    "data-name": "Path 4836",
    d: "M1776.295,700.081l-3.665.006-.021-1.191,3.669-.006Z",
    transform: "translate(-1764.364 -698.89)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293",
    transform: "translate(0.367 15.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4837",
    "data-name": "Path 4837",
    d: "M1717.445,715.573l-3.666.007-.029-1.188,3.67-.007Z",
    transform: "translate(-1713.75 -714.37)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4838",
    "data-name": "Path 4838",
    d: "M1747.016,715.519l-3.662.007-.025-1.188,3.666-.007Z",
    transform: "translate(-1739.212 -714.324)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4839",
    "data-name": "Path 4839",
    d: "M1776.559,715.464l-3.659.007-.021-1.187,3.663-.007Z",
    transform: "translate(-1764.649 -714.277)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2294",
    "data-name": "Group 2294",
    transform: "translate(0.418 17.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4840",
    "data-name": "Path 4840",
    d: "M1717.81,730.918l-3.66.008-.029-1.184,3.663-.008Z",
    transform: "translate(-1714.122 -729.717)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4841",
    "data-name": "Path 4841",
    d: "M1747.331,730.856l-3.656.008-.025-1.184,3.66-.008Z",
    transform: "translate(-1739.539 -729.665)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    d: "M1776.822,730.794l-3.652.008-.021-1.183,3.656-.008Z",
    transform: "translate(-1764.932 -729.611)",
    fill: "#d1d8df"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307",
    transform: "translate(25.881 13.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    d: "M1904.1,597.568c-.006-.221-.288-.4-.632-.4h-13.027c-.349,0-.692.192-.692.416v20.042a.4.4,0,0,0,.216.288.9.9,0,0,0,.463.118l13.62-.024a.848.848,0,0,0,.454-.122.352.352,0,0,0,.182-.294Z",
    transform: "translate(-1889.747 -597.165)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306",
    transform: "translate(1.017 1.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4844",
    "data-name": "Path 4844",
    d: "M1900.8,606.56l-3.711,0-.03-1.221h3.715Z",
    transform: "translate(-1897.056 -605.336)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M1930.73,606.56l-3.707,0-.025-1.221h3.711Z",
    transform: "translate(-1922.83 -605.336)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M1960.633,606.559l-3.7,0-.021-1.22h3.707Z",
    transform: "translate(-1948.577 -605.336)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    "data-name": "Group 2298",
    transform: "translate(0.053 2.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M1901.17,622.382h-3.7l-.029-1.213h3.708Z",
    transform: "translate(-1897.437 -621.167)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M1931.052,622.373h-3.7l-.025-1.212h3.7Z",
    transform: "translate(-1923.165 -621.16)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    d: "M1960.9,622.365l-3.7,0-.021-1.212h3.7Z",
    transform: "translate(-1948.868 -621.153)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    "data-name": "Group 2299",
    transform: "translate(0.106 4.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M1901.543,638.048l-3.7,0-.029-1.209,3.7,0Z",
    transform: "translate(-1897.815 -636.835)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    d: "M1931.372,638.032l-3.694,0-.025-1.208,3.7,0Z",
    transform: "translate(-1923.5 -636.822)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    d: "M1961.171,638.016l-3.691,0-.021-1.208,3.694,0Z",
    transform: "translate(-1949.157 -636.809)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300",
    transform: "translate(0.158 6.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    d: "M1901.914,653.661l-3.692,0-.029-1.2,3.7,0Z",
    transform: "translate(-1898.193 -652.45)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    d: "M1931.692,653.637l-3.688,0-.025-1.2,3.691,0Z",
    transform: "translate(-1923.833 -652.43)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    d: "M1961.439,653.613l-3.684,0-.021-1.2,3.688,0Z",
    transform: "translate(-1949.446 -652.41)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    transform: "translate(0.211 8.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4856",
    "data-name": "Path 4856",
    d: "M1902.284,669.219l-3.685,0-.03-1.2,3.689,0Z",
    transform: "translate(-1898.569 -668.01)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4857",
    "data-name": "Path 4857",
    d: "M1932.009,669.187l-3.681,0-.025-1.2,3.685,0Z",
    transform: "translate(-1924.164 -667.984)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4858",
    "data-name": "Path 4858",
    d: "M1961.706,669.155l-3.678,0-.021-1.2,3.681,0Z",
    transform: "translate(-1949.734 -667.957)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302",
    transform: "translate(0.263 10.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4859",
    "data-name": "Path 4859",
    d: "M1902.653,684.724l-3.679.005-.029-1.2,3.682,0Z",
    transform: "translate(-1898.945 -683.517)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4860",
    "data-name": "Path 4860",
    d: "M1932.327,684.684l-3.675.005-.025-1.2,3.678,0Z",
    transform: "translate(-1924.495 -683.484)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4861",
    "data-name": "Path 4861",
    d: "M1961.971,684.645l-3.672.005-.021-1.2,3.675,0Z",
    transform: "translate(-1950.02 -683.45)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303",
    transform: "translate(0.315 13.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4862",
    "data-name": "Path 4862",
    d: "M1903.02,700.175l-3.672.006-.029-1.193,3.676-.006Z",
    transform: "translate(-1899.318 -698.97)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4863",
    "data-name": "Path 4863",
    d: "M1932.643,700.128l-3.669.006-.025-1.192,3.673-.006Z",
    transform: "translate(-1924.825 -698.93)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4864",
    "data-name": "Path 4864",
    d: "M1962.236,700.081l-3.665.006-.021-1.191,3.669-.006Z",
    transform: "translate(-1950.306 -698.89)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304",
    transform: "translate(0.367 15.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4865",
    "data-name": "Path 4865",
    d: "M1903.386,715.573l-3.666.007-.029-1.188,3.67-.007Z",
    transform: "translate(-1899.691 -714.37)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4866",
    "data-name": "Path 4866",
    d: "M1932.957,715.519l-3.662.007-.025-1.188,3.666-.007Z",
    transform: "translate(-1925.153 -714.324)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4867",
    "data-name": "Path 4867",
    d: "M1962.5,715.464l-3.659.007-.02-1.187,3.662-.007Z",
    transform: "translate(-1950.59 -714.277)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305",
    transform: "translate(0.418 17.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4868",
    "data-name": "Path 4868",
    d: "M1903.751,730.918l-3.661.008-.028-1.184,3.663-.008Z",
    transform: "translate(-1900.062 -729.717)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4869",
    "data-name": "Path 4869",
    d: "M1933.271,730.856l-3.656.008-.025-1.184,3.66-.008Z",
    transform: "translate(-1925.48 -729.665)",
    fill: "#d1d8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4870",
    "data-name": "Path 4870",
    d: "M1962.763,730.794l-3.653.008-.021-1.183,3.656-.008Z",
    transform: "translate(-1950.873 -729.611)",
    fill: "#d1d8df"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309",
    transform: "translate(43.123 16.282)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4871",
    "data-name": "Path 4871",
    d: "M2028.573,614.268c0-.125-.193-.227-.425-.227H2014.1c-.234,0-.484.1-.484.231v17.765c0,.095.1.186.223.253a1.067,1.067,0,0,0,.482.1l14.2-.021a1.018,1.018,0,0,0,.473-.107.3.3,0,0,0,.19-.257Z",
    transform: "translate(-2013.621 -614.042)",
    fill: "#d1d8df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    transform: "translate(2.207 0.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4872",
    "data-name": "Path 4872",
    d: "M2034.691,621.107l-4.594-.009,0-.311,4.588.008Z",
    transform: "translate(-2030.011 -620.787)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4873",
    "data-name": "Path 4873",
    d: "M2034.664,629.318l-4.613-.011,0-.314,4.608.011Z",
    transform: "translate(-2029.971 -627.851)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4874",
    "data-name": "Path 4874",
    d: "M2034.637,637.6l-4.632-.014v-.317l4.627.014Z",
    transform: "translate(-2029.932 -634.973)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M2034.611,645.945l-4.651-.017v-.319l4.646.016Z",
    transform: "translate(-2029.893 -642.154)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4876",
    "data-name": "Path 4876",
    d: "M2034.584,654.362l-4.67-.02v-.322l4.666.019Z",
    transform: "translate(-2029.853 -649.394)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4877",
    "data-name": "Path 4877",
    d: "M2034.529,671.407l-4.709-.026v-.327l4.7.025Z",
    transform: "translate(-2029.772 -664.057)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4878",
    "data-name": "Path 4878",
    d: "M2034.446,697.518l-4.77-.035,0-.336,4.764.035Z",
    transform: "translate(-2029.649 -686.518)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4879",
    "data-name": "Path 4879",
    d: "M2034.556,662.849l-4.69-.023V662.5l4.685.022Z",
    transform: "translate(-2029.812 -656.695)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4880",
    "data-name": "Path 4880",
    d: "M2034.5,680.038l-4.73-.029,0-.33,4.724.028Z",
    transform: "translate(-2029.731 -671.481)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4881",
    "data-name": "Path 4881",
    d: "M2034.473,688.741l-4.75-.032,0-.333,4.745.031Z",
    transform: "translate(-2029.69 -678.968)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4882",
    "data-name": "Path 4882",
    d: "M2034.417,706.37l-4.79-.039v-.339l4.785.038Z",
    transform: "translate(-2029.606 -694.133)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4883",
    "data-name": "Path 4883",
    d: "M2034.389,715.3l-4.811-.042,0-.342,4.805.041Z",
    transform: "translate(-2029.564 -701.812)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4884",
    "data-name": "Path 4884",
    d: "M2034.36,724.3l-4.831-.045,0-.344,4.826.044Z",
    transform: "translate(-2029.522 -709.558)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    d: "M2034.33,733.383l-4.852-.049,0-.347,4.847.048Z",
    transform: "translate(-2029.479 -717.37)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4886",
    "data-name": "Path 4886",
    d: "M2077.754,621.182l-4.623-.009,0-.313,4.617.008Z",
    transform: "translate(-2067.052 -620.85)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4887",
    "data-name": "Path 4887",
    d: "M2077.905,629.419l-4.642-.011,0-.315,4.636.011Z",
    transform: "translate(-2067.164 -627.937)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4888",
    "data-name": "Path 4888",
    d: "M2078.056,637.725l-4.661-.014-.005-.318,4.656.014Z",
    transform: "translate(-2067.278 -635.081)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4889",
    "data-name": "Path 4889",
    d: "M2078.21,646.1l-4.681-.017-.005-.32,4.676.017Z",
    transform: "translate(-2067.394 -642.286)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4890",
    "data-name": "Path 4890",
    d: "M2078.364,654.544l-4.7-.02-.005-.323,4.7.019Z",
    transform: "translate(-2067.509 -649.55)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4891",
    "data-name": "Path 4891",
    d: "M2078.678,671.645l-4.74-.026-.005-.329,4.735.025Z",
    transform: "translate(-2067.745 -664.261)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4892",
    "data-name": "Path 4892",
    d: "M2079.158,697.844l-4.8-.036-.005-.337,4.8.035Z",
    transform: "translate(-2068.106 -686.797)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4893",
    "data-name": "Path 4893",
    d: "M2078.522,663.059l-4.721-.023-.005-.326,4.715.022Z",
    transform: "translate(-2067.627 -656.875)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4894",
    "data-name": "Path 4894",
    d: "M2078.836,680.3l-4.76-.029-.005-.331,4.755.029Z",
    transform: "translate(-2067.864 -671.71)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4895",
    "data-name": "Path 4895",
    d: "M2079,689.037l-4.78-.032-.005-.334,4.774.032Z",
    transform: "translate(-2067.985 -679.222)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4896",
    "data-name": "Path 4896",
    d: "M2079.321,706.726l-4.822-.039-.005-.34,4.815.038Z",
    transform: "translate(-2068.229 -694.438)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4897",
    "data-name": "Path 4897",
    d: "M2079.485,715.684l-4.843-.042-.005-.343,4.837.041Z",
    transform: "translate(-2068.352 -702.144)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4898",
    "data-name": "Path 4898",
    d: "M2079.65,724.719l-4.864-.046-.006-.346,4.858.045Z",
    transform: "translate(-2068.475 -709.916)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4899",
    "data-name": "Path 4899",
    d: "M2079.817,733.833l-4.885-.049-.006-.349,4.879.048Z",
    transform: "translate(-2068.6 -717.756)",
    fill: "#d1d8df",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313",
    transform: "translate(19.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4900",
    "data-name": "Path 4900",
    d: "M1890.2,334.033a.579.579,0,0,1-.517.625h0a.579.579,0,0,1-.518-.625v-22.01a.579.579,0,0,1,.518-.625h0a.579.579,0,0,1,.517.625Z",
    transform: "translate(-1882.386 -311.398)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4901",
    "data-name": "Path 4901",
    d: "M1875.865,428.826h-5.36a.7.7,0,0,0-.628.758v1.378h6.617v-1.378A.7.7,0,0,0,1875.865,428.826Z",
    transform: "translate(-1865.779 -412.482)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4902",
    "data-name": "Path 4902",
    d: "M1867.176,439.416h-7.159a1.339,1.339,0,0,0-1.2,1.445V442.3h9.553v-1.439A1.339,1.339,0,0,0,1867.176,439.416Z",
    transform: "translate(-1856.261 -421.598)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4903",
    "data-name": "Path 4903",
    d: "M1853.572,456.622h-11.937a1.338,1.338,0,0,0-1.2,1.445v38.017a.748.748,0,0,0,.669.808H1854.1a.748.748,0,0,0,.669-.808V458.067A1.339,1.339,0,0,0,1853.572,456.622Z",
    transform: "translate(-1840.438 -436.409)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4904",
    "data-name": "Path 4904",
    d: "M1845.243,497.887l6.666-40.108,6.327,40.108Z",
    transform: "translate(-1844.574 -437.404)",
    fill: "#dbe3eb"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4905",
    "data-name": "Path 4905",
    d: "M1995.546,517.494H1985.5a.706.706,0,0,0-.706.706v19.174h11.455V518.2A.706.706,0,0,0,1995.546,517.494Z",
    transform: "translate(-1945.21 -488.808)",
    fill: "#dbe3eb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4906",
    "data-name": "Path 4906",
    d: "M1983.483,621.9h-14.7a.706.706,0,0,0-.706.706v16.558h16.109V622.609A.706.706,0,0,0,1983.483,621.9Z",
    transform: "translate(-1930.819 -578.684)",
    fill: "#dbe3eb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4907",
    "data-name": "Path 4907",
    d: "M2005.547,498.455h-6.185a.706.706,0,0,0-.706.706v1.944h7.6v-1.944A.706.706,0,0,0,2005.547,498.455Z",
    transform: "translate(-1957.14 -472.419)",
    fill: "#b8c2cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314",
    transform: "translate(40.551 30.183)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4908",
    "data-name": "Path 4908",
    d: "M2000.983,528.7a.458.458,0,0,1-.458.458h-8.353a.458.458,0,0,1-.457-.458h0a.458.458,0,0,1,.457-.457h8.353a.458.458,0,0,1,.458.457Z",
    transform: "translate(-1991.715 -528.246)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4909",
    "data-name": "Path 4909",
    d: "M2000.983,545.14a.458.458,0,0,1-.458.457h-8.353a.458.458,0,0,1-.457-.457h0a.458.458,0,0,1,.457-.457h8.353a.458.458,0,0,1,.458.457Z",
    transform: "translate(-1991.715 -542.394)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4910",
    "data-name": "Path 4910",
    d: "M2000.983,561.575a.458.458,0,0,1-.458.457h-8.353a.458.458,0,0,1-.457-.457h0a.458.458,0,0,1,.457-.458h8.353a.458.458,0,0,1,.458.458Z",
    transform: "translate(-1991.715 -556.543)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4911",
    "data-name": "Path 4911",
    d: "M2000.983,578.012a.458.458,0,0,1-.458.458h-8.353a.458.458,0,0,1-.457-.458h0a.458.458,0,0,1,.457-.458h8.353a.458.458,0,0,1,.458.458Z",
    transform: "translate(-1991.715 -570.691)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4912",
    "data-name": "Path 4912",
    d: "M2000.983,594.447a.458.458,0,0,1-.458.457h-8.353a.458.458,0,0,1-.457-.457h0a.458.458,0,0,1,.457-.457h8.353a.458.458,0,0,1,.458.457Z",
    transform: "translate(-1991.715 -584.839)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4913",
    "data-name": "Path 4913",
    d: "M2000.983,610.59a.458.458,0,0,1-.458.457h-8.353a.458.458,0,0,1-.457-.457h0a.458.458,0,0,1,.457-.457h8.353a.458.458,0,0,1,.458.457Z",
    transform: "translate(-1991.715 -598.735)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315",
    transform: "translate(38.522 44.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4914",
    "data-name": "Path 4914",
    d: "M1990.865,633.48a.415.415,0,0,1-.415.415h-12.891a.415.415,0,0,1-.416-.415h0a.415.415,0,0,1,.416-.415h12.891a.415.415,0,0,1,.415.415Z",
    transform: "translate(-1977.142 -633.065)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4915",
    "data-name": "Path 4915",
    d: "M1990.865,650.272a.415.415,0,0,1-.415.415h-12.891a.415.415,0,0,1-.416-.415h0a.415.415,0,0,1,.416-.415h12.891a.415.415,0,0,1,.415.415Z",
    transform: "translate(-1977.142 -647.52)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4916",
    "data-name": "Path 4916",
    d: "M1990.865,667.063a.415.415,0,0,1-.415.415h-12.891a.415.415,0,0,1-.416-.415h0a.415.415,0,0,1,.416-.415h12.891a.415.415,0,0,1,.415.415Z",
    transform: "translate(-1977.142 -661.974)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4917",
    "data-name": "Path 4917",
    d: "M1990.865,683.854a.415.415,0,0,1-.415.415h-12.891a.415.415,0,0,1-.416-.415h0a.415.415,0,0,1,.416-.415h12.891a.415.415,0,0,1,.415.415Z",
    transform: "translate(-1977.142 -676.428)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4918",
    "data-name": "Path 4918",
    d: "M1990.865,700.646a.415.415,0,0,1-.415.415h-12.891a.415.415,0,0,1-.416-.415h0a.415.415,0,0,1,.416-.415h12.891a.415.415,0,0,1,.415.415Z",
    transform: "translate(-1977.142 -690.883)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4919",
    "data-name": "Path 4919",
    d: "M1990.865,717.437a.415.415,0,0,1-.415.415h-12.891a.415.415,0,0,1-.416-.415h0a.415.415,0,0,1,.416-.415h12.891a.415.415,0,0,1,.415.415Z",
    transform: "translate(-1977.142 -705.336)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4920",
    "data-name": "Path 4920",
    d: "M1990.865,734.229a.415.415,0,0,1-.415.415h-12.891a.415.415,0,0,1-.416-.415h0a.415.415,0,0,1,.416-.415h12.891a.415.415,0,0,1,.415.415Z",
    transform: "translate(-1977.142 -719.791)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2317",
    "data-name": "Group 2317",
    transform: "translate(-7.339 36.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4921",
    "data-name": "Path 4921",
    d: "M1577.486,572.4s.8-7.542,3.493-7.48,2-4.487,4.693-4.655,11.774-2.317,12.447,4.649-.174,17.589,1.005,18.094,1.51,3.047,1.51,3.047h-23.064Z",
    transform: "translate(-1537.607 -558.04)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4922",
    "data-name": "Path 4922",
    d: "M1290.97,574.412s1.225-14.791,2.45-14.791a17.285,17.285,0,0,0,3.486-.659s.565-12.059,2.732-11.965,10.363.565,10.363,3.769-1.036,11.588,0,11.776,3.863.848,3.863,2.167,2.261,9.139,2.261,9.139l-25.155.848Z",
    transform: "translate(-1290.97 -546.996)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4923",
    "data-name": "Path 4923",
    d: "M1445.174,578.424s-8.691-.918-8.408,2.379-1.519,3.827-2.65,4.675-.006,7.331-.006,8.556-6.38,1.29-5.729,3.639a5.566,5.566,0,0,1-.684,4.294h27.227s-.754-6.99-2.544-7.273-2.544-3.212-2.544-3.212S1449.178,579.6,1445.174,578.424Z",
    transform: "translate(-1408.667 -573.948)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4924",
    "data-name": "Path 4924",
    d: "M1590.217,619.761s-5.123.424-5.123,2.073-.63,5.7-.63,5.7-3.636.377-3.542,1.837-1.182,4.193-1.182,4.193-1.51,1.243-1.557,2.373a16.237,16.237,0,0,0,0,1.714h15.875s.236-3.787-.848-4.069-1.178.274-1.272-1.234S1592.832,619.666,1590.217,619.761Z",
    transform: "translate(-1538.188 -609.632)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4925",
    "data-name": "Path 4925",
    d: "M1321.249,637.689s-.589-7.833.589-8.069,1.637-1.137,1.684-2.55.441-6.763,1.855-6.951,3.542-.484,3.73.5,1.135,7.342,1.135,7.342,1.887-.1,2.075.727a33.6,33.6,0,0,1-.234,4.826s1.932-.257,2.356,1.062a19.826,19.826,0,0,1,.519,3.936h-16.252S1318.517,637.618,1321.249,637.689Z",
    transform: "translate(-1314.843 -609.775)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4926",
    "data-name": "Path 4926",
    d: "M1492.653,665.4s-3.25.989-3.156,2.567,0,3.463,0,3.463-2.165-.377-2.448.612-.8,4.852-.8,4.852l10.269.565s.848-5.04,0-5.417a3.62,3.62,0,0,0-1.555-.33S1495.762,665.115,1492.653,665.4Z",
    transform: "translate(-1459.066 -648.909)",
    fill: "#dbe3eb"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318",
    transform: "translate(40.951 8.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2426",
    "data-name": "Rectangle 2426",
    d: "M4.707,0h2.91a4.707,4.707,0,0,1,4.707,4.707v7.1A2.725,2.725,0,0,1,9.6,14.537H4.707A4.707,4.707,0,0,1,0,9.829V4.707A4.707,4.707,0,0,1,4.707,0Z",
    transform: "translate(1.937 44.97)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4927",
    "data-name": "Path 4927",
    d: "M1655.389,760.789a2.684,2.684,0,0,0-2.677-2.676h-10.846c-1.472,0-2.184,1.2-2.184,2.676v.7h15.706Z",
    transform: "translate(-1639.437 -701.176)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4928",
    "data-name": "Path 4928",
    d: "M1681.608,462.99a3.064,3.064,0,0,0-1.356-1.743c-.092-.038-.3.057-.4-.053s-.051-.332.015-.508a2.132,2.132,0,0,1-.7.233,2.273,2.273,0,0,1-1.456-.3q-.064.263-.126.526l-1.643-.042c-.923,6.074.641,11.039,3.7,12.334a4.862,4.862,0,0,0,2.639.283c-.011-.135-.069-.9-.069-.9s-.053-1.972.053-3.1S1682.62,465.208,1681.608,462.99Z",
    transform: "translate(-1670.415 -445.087)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4929",
    "data-name": "Path 4929",
    d: "M1645.083,365.064a5.04,5.04,0,0,1-1.612-1.128,2.512,2.512,0,0,1-.827-1.281c-.106-.458-.211-5.476-.264-6.092a7.741,7.741,0,0,1,.3-1.426c.557-2.568.754-3.035.555-3.863a4.521,4.521,0,0,0-.837-1.613c-.245-.372-.466-.6-.744-.613-.587-.024-1.247,1.043-1.475,2.057-.2.913.007,1.914.431,3.917.2.934.454,1.955,0,2.307-.174.134-.62.3-.777.689a1.266,1.266,0,0,0-.062.221,1.29,1.29,0,0,0,.059.613c.229.646.877.691,1.233,1.092.623.7-.378,1.675-.282,3.381.079,1.4.8,1.61,1.526,3.944a14.487,14.487,0,0,1,.517,2.324c.251,4.284.24,7.563.176,9.825a56.412,56.412,0,0,0-.141,6.691,13.675,13.675,0,0,1,0,3.434,11.353,11.353,0,0,1-1.421,4l11.916-.123a12.175,12.175,0,0,1-1.308-3.327,17.41,17.41,0,0,1-.206-5.266c.183-2.975.624-3.564.176-4.719a9.959,9.959,0,0,1-.651-2.412v-.014a11.654,11.654,0,0,1-4.281-5.648C1646.226,369.413,1646.77,365.969,1645.083,365.064Z",
    transform: "translate(-1639.497 -349.047)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4930",
    "data-name": "Path 4930",
    d: "M1675.637,408.082c0-.036-.006-.07-.009-.1.664-.164,1.819-.475,1.794-.687s-1.344-.236-2.017-.23l-.284-.477c.156-.283.943-1.721.727-1.875s-1.311,1.043-1.531,1.285l-.795-.181c-.235-1.154-.551-2.464-.773-2.442s-.273,1.222-.283,2.423l-.761.191c-.593-.655-1.365-1.456-1.515-1.347s.417,1.162.859,1.923l-.266.6c-.412.035-1.736.159-1.743.385s1.2.426,1.625.5a4.971,4.971,0,0,0,.153,1.217c.273,1.074,1.126,2.893,2.258,2.945C1674.389,412.271,1675.783,409.934,1675.637,408.082Z",
    transform: "translate(-1664.708 -395.813)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2427",
    "data-name": "Rectangle 2427",
    width: 16.199,
    height: 3.733,
    rx: 1.866,
    transform: "translate(0 44.119)",
    fill: "#dbe3eb"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5129",
    "data-name": "Path 5129",
    d: "M5.7,0A5.7,5.7,0,1,1,0,5.7,5.7,5.7,0,0,1,5.7,0Z",
    transform: "translate(12.775 6.478)",
    fill: "#dbe3eb"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5041",
    "data-name": "Path 5041",
    d: "M756.7,369.7l-7.621-4.729a.722.722,0,0,0-.526-.094l-9.917,2.028a.723.723,0,0,0-.339,1.245l5.939,5.344Z",
    transform: "translate(-639.723 331.169)",
    fill: "#d1d8df"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5042",
    "data-name": "Path 5042",
    d: "M370.616,367.21s92.426-16.5,96.031-15.349,10.049,4.985,11.95,4.993,8.546,1.178,6.815,5.921S407.036,382,398.118,378.923s-31.505-8.88-31.505-8.88S364.537,366.8,370.616,367.21Z",
    transform: "translate(-319.685 342.408)",
    fill: "#dbe3eb"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5043",
    "data-name": "Path 5043",
    d: "M396.075,306.018l-13.289-7.4a5.1,5.1,0,0,1-1.981-1.988l-5.368-9.719a2,2,0,0,0-2.165-.992c-2.756.58-8.475,1.86-8.5,2.509-.037.855,2.736,22.323,2.736,22.323Z",
    transform: "translate(-318.391 399.162)",
    fill: "#dbe3eb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5044",
    "data-name": "Path 5044",
    d: "M396.345,467.8l-1.111,4.525a2.5,2.5,0,0,0,.47,2.16,2.537,2.537,0,0,0,2.011.957l4.7.021a2.538,2.538,0,0,0,1.938-.841l8.4-9.537Z",
    transform: "translate(-344.554 244.898)",
    fill: "#d1d8df"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5045",
    "data-name": "Path 5045",
    d: "M735.849,522.265a10.4,10.4,0,0,0,7.467,3.525c4.632.02,10.338-1.237,11.414-2.871s3.409-13.731-6-12.03S728.314,518.027,735.849,522.265Z",
    transform: "translate(-635.668 205.606)",
    fill: "#dbe3eb"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5046",
    "data-name": "Path 5046",
    d: "M637.194,480.2l21.965-3.79L640.647,500.04a1.507,1.507,0,0,1-1.065.572l-13.154,1.056a1.506,1.506,0,0,1-1.392-2.309Z",
    transform: "translate(-542.231 235.141)",
    fill: "#d1d8df"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5047",
    "data-name": "Path 5047",
    d: "M856.117,532.522a.487.487,0,0,0,.165.008c.294-.038.589-.342.878-.9a10.273,10.273,0,0,0-.051-8.614h0a2.856,2.856,0,0,0-2.322-1.507,1.908,1.908,0,0,0-2.177,1.644c-.52,2.293,1.667,7.587,2.91,8.954A1.229,1.229,0,0,0,856.117,532.522Zm-1.027-10.568a2.488,2.488,0,0,1,1.665,1.249h0a9.986,9.986,0,0,1,.049,8.242c-.25.486-.465.675-.573.688-.014,0-.138.008-.416-.3-1.293-1.422-3.275-6.57-2.815-8.6a1.512,1.512,0,0,1,1.758-1.333A2.429,2.429,0,0,1,855.09,521.953Z",
    transform: "translate(-738.264 196.332)",
    fill: "#b8c2cb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5048",
    "data-name": "Path 5048",
    d: "M368.466,340.8l2.28.01,2.073,14.566-2.4.55Z",
    transform: "translate(-321.575 351.882)",
    fill: "#d1d8df"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325",
    transform: "translate(84.292 697.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    "data-name": "Group 2324",
    transform: "translate(0 4.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5049",
    "data-name": "Path 5049",
    d: "M637.175,459.4a1.358,1.358,0,0,1,1.364-1.352h.086a1.358,1.358,0,0,1,1.352,1.364l0,.887a1.358,1.358,0,0,1-1.364,1.352h-.086a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-637.171 -450.261)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5050",
    "data-name": "Path 5050",
    d: "M674.585,456.689a1.358,1.358,0,0,1,1.364-1.352h.086a1.358,1.358,0,0,1,1.352,1.364l0,.887a1.358,1.358,0,0,1-1.364,1.352h-.087a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-669.374 -447.927)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5051",
    "data-name": "Path 5051",
    d: "M712.02,448.224a1.359,1.359,0,0,1,1.364-1.352h.086a1.358,1.358,0,0,1,1.352,1.364l0,.887a1.358,1.358,0,0,1-1.364,1.352h-.086a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-701.598 -440.64)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5052",
    "data-name": "Path 5052",
    d: "M746.566,442.623a1.358,1.358,0,0,1,1.364-1.352h.086a1.358,1.358,0,0,1,1.352,1.364l0,.887A1.358,1.358,0,0,1,748,444.875h-.087a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-731.336 -435.818)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5053",
    "data-name": "Path 5053",
    d: "M786.865,437.047a1.358,1.358,0,0,1,1.364-1.352h.086a1.359,1.359,0,0,1,1.352,1.364l0,.887A1.358,1.358,0,0,1,788.3,439.3h-.086a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-766.026 -431.019)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5054",
    "data-name": "Path 5054",
    d: "M824.288,431.459a1.358,1.358,0,0,1,1.364-1.352h.086a1.358,1.358,0,0,1,1.352,1.364l0,.887a1.359,1.359,0,0,1-1.364,1.352h-.086a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-798.24 -426.208)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5055",
    "data-name": "Path 5055",
    d: "M861.724,422.993a1.358,1.358,0,0,1,1.364-1.352h.086a1.358,1.358,0,0,1,1.352,1.364l0,.887a1.358,1.358,0,0,1-1.364,1.352h-.086a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-830.465 -418.921)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5056",
    "data-name": "Path 5056",
    d: "M896.257,420.269a1.358,1.358,0,0,1,1.364-1.352h.086a1.358,1.358,0,0,1,1.352,1.364l0,.887a1.358,1.358,0,0,1-1.364,1.352h-.086a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-860.192 -416.576)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5057",
    "data-name": "Path 5057",
    d: "M933.679,414.68a1.358,1.358,0,0,1,1.364-1.352h.086a1.358,1.358,0,0,1,1.352,1.364l0,.887a1.358,1.358,0,0,1-1.364,1.352h-.086a1.358,1.358,0,0,1-1.352-1.364Z",
    transform: "translate(-892.405 -411.765)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2428",
    "data-name": "Rectangle 2428",
    d: "M1.4,0h.8A1.4,1.4,0,0,1,3.6,1.4v0A1.4,1.4,0,0,1,2.2,2.8H1.4A1.4,1.4,0,0,1,0,1.4v0A1.4,1.4,0,0,1,1.4,0Z",
    transform: "translate(46.475 3.983) rotate(-89.75)",
    fill: "#b8c2cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2429",
    "data-name": "Rectangle 2429",
    d: "M1.4,0h.8A1.4,1.4,0,0,1,3.6,1.4v0A1.4,1.4,0,0,1,2.2,2.8H1.4A1.4,1.4,0,0,1,0,1.4v0A1.4,1.4,0,0,1,1.4,0Z",
    transform: "translate(51.282 3.604) rotate(-89.76)",
    fill: "#b8c2cb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5058",
    "data-name": "Path 5058",
    d: "M1070.4,372.941l-9.144,2.5a1.478,1.478,0,0,0-1.083,1.549c.071.843.195,1.8.383,1.717.333-.141,14.667-3.714,14.667-3.714Z",
    transform: "translate(-1001.29 -372.941)",
    fill: "#b8c2cb"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5059",
    "data-name": "Path 5059",
    d: "M399.744,896.738s2.456-6.018-6.807-4.8-7.012,4.71-7.744,7.443-4.618,5.83-15.433,10.046-7.608,15.711-2.751,19.527,7.506,1.279,8.636,7.864,5.637,11.933,11.26,6.351,12.014-12.183,10.227-20.839.237-7.018,3.726-10.989S396.953,903.523,399.744,896.738Z",
    transform: "translate(-316.446 -122.404)",
    fill: "#b8c2cb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5060",
    "data-name": "Path 5060",
    d: "M618.385,909.923s-9.335,13.162-19.714,15.247c0,0,1.693,5.789,3.2,6.521,0,0,13.156-9.84,16.933-19.805Z",
    transform: "translate(-519.738 -138.028)",
    fill: "#dbe3eb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5061",
    "data-name": "Path 5061",
    d: "M406.522,1517.16l-.279,2.3a3.08,3.08,0,0,1-1.523,1.593,7.027,7.027,0,0,1-2.212.129c-.508-.054-1.009-1.411-.854-1.9a8.368,8.368,0,0,1,1.541-3h2.549A.785.785,0,0,1,406.522,1517.16Z",
    transform: "translate(-350.118 -659.988)",
    fill: "#b8c2cb"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5062",
    "data-name": "Path 5062",
    d: "M549.808,1329.246l.43,2.53s-1.441,14.591-1.7,20.428a4.575,4.575,0,0,0,.677,2.6l2.5,4.068-6.366-3.756-.127-.777,1.042-1.433-1.365-16.345a5.015,5.015,0,0,1,.571-2.774l1.317-2.474Z",
    transform: "translate(-473.443 -498.987)",
    fill: "#dbe3eb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5063",
    "data-name": "Path 5063",
    d: "M551.147,1508.966h-2.032a1.223,1.223,0,0,1-.971-.476c-.633-.823-1.945-2.429-2.573-2.47-.845-.056-.737,2.946-.737,2.946h-.473l-.6-3.731a2.209,2.209,0,0,1,1.159-2.309h0a3.122,3.122,0,0,0,1.24,2.059c1.047.632,4.26,2.894,4.26,2.894a2.907,2.907,0,0,1,.826.022A.537.537,0,0,1,551.147,1508.966Z",
    transform: "translate(-472.448 -648.493)",
    fill: "#b8c2cb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5064",
    "data-name": "Path 5064",
    d: "M423.222,1331.377s-8.439,16.008-9.781,19.663a35.1,35.1,0,0,0-1.829,6.992c-.028.451-.589.884-2.136.884a1.484,1.484,0,0,1-1.381-.63.9.9,0,0,1-.034-.873c.488-.988,2.037-4.145,2.611-5.577.685-1.71,2.159-9.458,2.967-12.152s1.722-5.616,5.241-8.307C418.879,1331.377,421.3,1329.011,423.222,1331.377Z",
    transform: "translate(-355.576 -499.916)",
    fill: "#dbe3eb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5065",
    "data-name": "Path 5065",
    d: "M535.237,1030.063c2.177-9.224-3.338-14.441-3.338-14.441,3.48-3.34,9.82-4.86,9.82-4.86s6.049,4.423,5.332,7.885c-.421,2.029-4.253,12.153-4.253,12.153A8.418,8.418,0,0,1,535.237,1030.063Z",
    transform: "translate(-462.26 -224.832)",
    fill: "#d1d8df"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5066",
    "data-name": "Path 5066",
    d: "M489.571,1154c.886-2.669,4.827-4.567,4.827-4.567a8.419,8.419,0,0,0,7.561.737,15.163,15.163,0,0,1,.246,5.86c-.548,2.823-3.989,20.962-3.989,20.962-5.421,1.1-13.76-1.1-13.76-1.1C487.909,1169.755,488.685,1156.669,489.571,1154Z",
    transform: "translate(-421.42 -344.202)",
    fill: "#d1d8df"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5067",
    "data-name": "Path 5067",
    d: "M562.917,962.28l-1.77,7.949c-.169.7.469.586,1.177.452,1.16-.218,2.654-.669,3.153-1.571a.857.857,0,0,0,.091-.3l.76-5.512a.99.99,0,0,0-.58-1.041l-1.467-.65A.99.99,0,0,0,562.917,962.28Z",
    transform: "translate(-487.414 -182.445)",
    fill: "#dbe3eb"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5068",
    "data-name": "Path 5068",
    d: "M494.855,1045.679s-12.353,8.838-1.58,18.124a2.783,2.783,0,0,0,1.219.706,13.416,13.416,0,0,1,2.227,1.511.419.419,0,0,0,.613-.11h0a.573.573,0,0,0,.032-.549l-1.529-3.234a1.18,1.18,0,0,0-1.532-.067h0a.582.582,0,0,1-.882-.2c-.833-1.7-2.405-6.685,4.031-12.322a.7.7,0,0,0,.155-.848C497.156,1047.824,496.121,1046.1,494.855,1045.679Z",
    transform: "translate(-425.216 -254.889)",
    fill: "#dbe3eb"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5069",
    "data-name": "Path 5069",
    d: "M565.869,911.812a7.843,7.843,0,0,1,3.521,3.914c1.425,3.029.361,4.427-.976,4.619a6.258,6.258,0,0,1-5.451-1.794C560.849,916.595,563.144,910.763,565.869,911.812Z",
    transform: "translate(-488.289 -139.547)",
    fill: "#dbe3eb"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5070",
    "data-name": "Path 5070",
    d: "M550.114,900.237s-1.581-4.431,2.348-4.484l.924.646s1.442-2.457-.924-3.63-5.135-.2-6.142,2.983-1.179,5.322.5,6.847,2.365-.2,2.365-.2-.912-1.427-.541-2.19,1.228.158,1.228.158Z",
    transform: "translate(-474.018 -122.849)",
    fill: "#b8c2cb"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5071",
    "data-name": "Path 5071",
    d: "M564.643,946.116s-.8-2.283-1.866-1.374.867,2.109,1.624,2.5Z",
    transform: "translate(-488.57 -167.817)",
    fill: "#dbe3eb"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328",
    transform: "translate(97.126 767.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5072",
    "data-name": "Path 5072",
    d: "M730.693,883.044c.011.283-1.044.421-1.313-.794.119-.515.4-2.784.82-3.116a42.173,42.173,0,0,1,6.123-3.689.776.776,0,0,1-.189,1.065l-1.958,1.175a7.658,7.658,0,0,1,.412,2,2.215,2.215,0,0,1-.641,1.516c-.4.41-.935.938-1.414,1.335A2.188,2.188,0,0,1,730.693,883.044Z",
    transform: "translate(-729.38 -875.444)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5073",
    "data-name": "Path 5073",
    d: "M739.307,899.5l.756-1.055,1.711-.8c.248.226.343.513-.1.933a16.593,16.593,0,0,0-1.5,2.635Z",
    transform: "translate(-737.925 -894.557)",
    fill: "#dbe3eb"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329",
    transform: "translate(48.762 772.626)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5074",
    "data-name": "Path 5074",
    d: "M497.286,925.97a.036.036,0,0,1-.012-.07c3.9-1.357,5.826-3.829,5.42-6.962-.418-3.227,1.6-3.754,1.619-3.759a.036.036,0,1,1,.017.07c-.02,0-1.973.52-1.564,3.679s-1.531,5.67-5.468,7.04Z",
    transform: "translate(-481.196 -915.178)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5075",
    "data-name": "Path 5075",
    d: "M389.876,1062.995a.035.035,0,0,1-.018,0c-4.429-2.46-7.038-5.432-7.753-8.832a10.934,10.934,0,0,1,1.8-8.1.037.037,0,0,1,.051-.007.036.036,0,0,1,.007.051,10.858,10.858,0,0,0-1.782,8.039c.711,3.379,3.307,6.334,7.717,8.783a.036.036,0,0,1-.018.068Z",
    transform: "translate(-381.91 -1027.832)",
    fill: "#91b3fa"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5076",
    "data-name": "Path 5076",
    d: "M1574.793,1060.008a26.461,26.461,0,0,1,9.764-14.765,18.761,18.761,0,0,0,7.589-11.877q.137-.756.339-1.517c2.046-7.683,8.412-12.658,14.219-11.112s8.856,9.029,6.81,16.712a18.622,18.622,0,0,1-1.755,4.34,18.847,18.847,0,0,0-1.966,13.767,27.659,27.659,0,0,1-.246,13.707c-1.9,7.143-6.212,12.806-11.369,15.8a18.461,18.461,0,0,0-5.1,4.371c-2.35,2.918-5.785,4.4-9.045,3.536-3.517-.937-5.847-4.352-6.2-8.453a19.712,19.712,0,0,0-1.838-6.684A26.4,26.4,0,0,1,1574.793,1060.008Z",
    transform: "translate(-1359.142 -233.175)",
    fill: "#dbe3eb"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5077",
    "data-name": "Path 5077",
    d: "M1656.908,1077.311c-2.11,4.876-4.063,9.815-5.964,14.776-.476,1.24-.932,2.487-1.391,3.733l-.689,1.869-.674,1.875c-.444,1.252-.906,2.5-1.336,3.754l-1.291,3.769c-.828,2.524-1.678,5.041-2.46,7.58-.392,1.269-.809,2.53-1.176,3.807l-1.118,3.825c-1.438,5.115-2.749,10.268-3.8,15.478l.224.047.932-3.868.231-.967.255-.962.514-1.921.51-1.922c.169-.641.361-1.276.541-1.914.368-1.274.725-2.551,1.1-3.823,1.536-5.077,3.14-10.134,4.848-15.157.873-2.5,1.724-5.017,2.615-7.516l.663-1.876.678-1.87c.452-1.247.9-2.495,1.368-3.737q1.361-3.74,2.778-7.459,1.4-3.726,2.851-7.432Z",
    transform: "translate(-1413.555 -282.118)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5078",
    "data-name": "Path 5078",
    d: "M1671.148,1269.612a19.242,19.242,0,0,1,11.213-6.281,13.648,13.648,0,0,0,8.848-5.142q.341-.442.725-.866c3.88-4.276,9.64-5.371,12.864-2.446s2.692,8.763-1.188,13.04a13.557,13.557,0,0,1-2.578,2.217,13.717,13.717,0,0,0-5.858,8.227,20.129,20.129,0,0,1-4.73,8.759,18.784,18.784,0,0,1-12.593,6.418,13.415,13.415,0,0,0-4.744,1.125,6.42,6.42,0,0,1-7-.722c-1.953-1.771-2.314-4.748-1.171-7.509a14.318,14.318,0,0,0,1.046-4.921A19.2,19.2,0,0,1,1671.148,1269.612Z",
    transform: "translate(-1437.031 -433.558)",
    fill: "#d1d8df"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5079",
    "data-name": "Path 5079",
    d: "M1713.618,1290.341c-2.986,2.444-5.891,4.982-8.769,7.55-.72.642-1.429,1.3-2.141,1.946l-1.067.977-1.059.985c-.7.659-1.416,1.309-2.113,1.977l-2.088,2c-1.375,1.353-2.762,2.694-4.112,4.072-.676.688-1.365,1.363-2.027,2.065l-2,2.1c-2.633,2.821-5.2,5.71-7.608,8.723l.129.1,1.89-2.186.471-.547.485-.536.972-1.069.97-1.07c.322-.357.658-.7.986-1.055.662-.7,1.318-1.4,1.984-2.1q4.024-4.147,8.177-8.166c1.4-1.326,2.784-2.663,4.191-3.979l1.053-.99,1.061-.981c.707-.655,1.414-1.309,2.127-1.956q2.123-1.961,4.276-3.889t4.315-3.847Z",
    transform: "translate(-1451.109 -465.497)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5081",
    "data-name": "Path 5081",
    d: "M2025.693,878.3s.4-6.15,6.372-6.086,16.269.064,16.269,5.418,3.063,24.6-1.955,26.45-19.744,2.868-20.982-.446S2025.643,878.709,2025.693,878.3Z",
    transform: "translate(-1747.456 -105.567)",
    fill: "#d1d8df"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5083",
    "data-name": "Path 5083",
    d: "M2134.76,1507.983a.659.659,0,0,0-.018-.169c-.841-3.336-4.281-5.045-4.281-5.045l-1.655.13c-.951,2.94-1.565,4.375-1.412,5.179,0,.022.011.044.017.066A39.286,39.286,0,0,0,2134.76,1507.983Z",
    transform: "translate(-1835.659 -648.357)",
    fill: "#d1d8df"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5084",
    "data-name": "Path 5084",
    d: "M2127.66,1540.391a.717.717,0,0,0,.525.53,22.692,22.692,0,0,0,6.324-.09.6.6,0,0,0,.5-.6A39.257,39.257,0,0,1,2127.66,1540.391Z",
    transform: "translate(-1835.908 -680.605)",
    fill: "#b8c2cb"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5085",
    "data-name": "Path 5085",
    d: "M2141.35,1484.268l-.724,3.488a.572.572,0,0,1-.488.47,4.844,4.844,0,0,1-1.122-.018.717.717,0,0,1-.568-.843l.5-3.1Z",
    transform: "translate(-1845.188 -632.431)",
    fill: "#f4f6f8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5086",
    "data-name": "Path 5086",
    d: "M1981.557,1538.383a9.552,9.552,0,0,0,3.154-.451c0,.176,0,.355-.006.54a.349.349,0,0,1-.333.355l-9.7-.063a.443.443,0,0,1-.357-.645C1975.584,1538.224,1978.825,1538.46,1981.557,1538.383Z",
    transform: "translate(-1703.866 -678.626)",
    fill: "#b8c2cb"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5087",
    "data-name": "Path 5087",
    d: "M1974.59,1509.87a.458.458,0,0,1,.038-.073,12.366,12.366,0,0,1,7.353-4.616l2.069-.066a9.931,9.931,0,0,1,.939,4.568,9.545,9.545,0,0,1-3.155.451C1979.1,1510.21,1975.862,1509.975,1974.59,1509.87Z",
    transform: "translate(-1704.145 -650.377)",
    fill: "#d1d8df"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5088",
    "data-name": "Path 5088",
    d: "M2028.732,1479.483c-.023.154-.306,2.5-.416,3.408a.451.451,0,0,1-.38.407,4.747,4.747,0,0,1-1.421-.022.612.612,0,0,1-.464-.614v-3.679Z",
    transform: "translate(-1748.442 -627.881)",
    fill: "#f4f6f8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    d: "M2040.219,1155.2s3.311,29.431,1.471,47.825a14.231,14.231,0,0,1-3.311-.368s-3.441-28.776-4.553-37.01a.277.277,0,0,0-.546-.017c-1.373,6.928-6.767,34.094-7.408,36.66a4.587,4.587,0,0,1-3.311,0s2.943-39.364,5.151-46.354Z",
    transform: "translate(-1745.438 -349.167)",
    fill: "#d1d8df"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5090",
    "data-name": "Path 5090",
    d: "M2042.291,904.48s-13.98-2.207-25.017.736l.736,11.4s2.943,15.819,5.151,22.809c0,0,8.461,1.471,12.508-.736,0,0,3.311-19.866,5.15-22.809C2040.819,915.885,2042.659,908.159,2042.291,904.48Z",
    transform: "translate(-1740.888 -132.659)",
    fill: "#dbe3eb"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5091",
    "data-name": "Path 5091",
    d: "M2094.933,837.173l1.392,9.418s-3.891,1.788-6.615-.076l.587-6.647Z",
    transform: "translate(-1803.242 -75.404)",
    fill: "#f4f6f8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5092",
    "data-name": "Path 5092",
    d: "M2075.42,796.48c-.065.063-2.278,4.348-3.646,7a2.063,2.063,0,0,0,1.106,2.875l1.056.4a4.018,4.018,0,0,0,5.031-2l2.361-4.842S2077.011,794.952,2075.42,796.48Z",
    transform: "translate(-1787.604 -40.124)",
    fill: "#f4f6f8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5093",
    "data-name": "Path 5093",
    d: "M2096.371,780.312a1.581,1.581,0,0,0,.584-2.249,2.23,2.23,0,0,0-2.426-1.157.742.742,0,0,1-.783-.425.472.472,0,0,0-.371-.287.694.694,0,0,1-.571-.809,1.83,1.83,0,0,0-1.042-2.086c-1.944-1.044-3.62.7-4.035,2.171s1.755,2.478,3.116,2.636c1,.117,1.558,1.2,1.784,1.768a.718.718,0,0,1-.047.628l-.764,1.3a6.733,6.733,0,0,0,.375,1.494,1.448,1.448,0,0,0,.6.712,2.453,2.453,0,0,1,2.231-.243.719.719,0,0,0,.57-.081,1.573,1.573,0,0,0,.569-2.4A.716.716,0,0,1,2096.371,780.312Z",
    transform: "translate(-1801.491 -20.148)",
    fill: "#b8c2cb"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5094",
    "data-name": "Path 5094",
    d: "M2118.37,847.083s.835-2.523,1.936-2.442,1.978,1.169.627,2.414C2119.252,848.6,2118.37,847.083,2118.37,847.083Z",
    transform: "translate(-1827.912 -81.832)",
    fill: "#f4f6f8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5095",
    "data-name": "Path 5095",
    d: "M2093.56,781.529a.038.038,0,0,1-.027-.012,1.741,1.741,0,0,1-.53-1.454,3.249,3.249,0,0,1,1.481-1.9.036.036,0,0,1,.05.012.036.036,0,0,1-.012.05,3.245,3.245,0,0,0-1.447,1.852,1.673,1.673,0,0,0,.513,1.394.037.037,0,0,1,0,.051A.038.038,0,0,1,2093.56,781.529Z",
    transform: "translate(-1806.062 -24.601)",
    fill: "#91b3fa"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5096",
    "data-name": "Path 5096",
    d: "M2173.115,909.4s21.706,23.545-3.863,32.558v-1.839s9.565-8.094,2.207-19.13C2171.46,920.984,2172.38,910.5,2173.115,909.4Z",
    transform: "translate(-1871.712 -137.574)",
    fill: "#dbe3eb"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5097",
    "data-name": "Path 5097",
    d: "M2129.253,1121.386s-3.311-2.208-4.783-1.472a2.275,2.275,0,0,0-1.472,1.84s.736,1.472,1.839,1.1,3.679.368,4.783,0C2129.62,1122.857,2129.988,1121.386,2129.253,1121.386Z",
    transform: "translate(-1831.896 -318.662)",
    fill: "#f4f6f8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5098",
    "data-name": "Path 5098",
    d: "M1960.147,914.681s-22.625,22.809,2.943,31.822v-1.839s-9.565-8.094-2.207-19.13C1960.883,925.534,1961.619,916.521,1960.147,914.681Z",
    transform: "translate(-1683.762 -142.124)",
    fill: "#dbe3eb"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5099",
    "data-name": "Path 5099",
    d: "M2036.9,1121.386s3.311-2.208,4.783-1.472a2.275,2.275,0,0,1,1.472,1.84s-.736,1.472-1.84,1.1-3.679.368-4.782,0C2036.529,1122.857,2036.161,1121.386,2036.9,1121.386Z",
    transform: "translate(-1757.383 -318.662)",
    fill: "#f4f6f8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5100",
    "data-name": "Path 5100",
    d: "M2151.168,889.233c.535-1.75,2.264-1.425,3.718-.774a1.855,1.855,0,0,1,.868,2.579c-2.443,4.482,1.022,17.8-.873,19.634C2152.732,912.757,2150.191,892.426,2151.168,889.233Z",
    transform: "translate(-1855.96 -119.103)",
    fill: "#d1d8df"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5101",
    "data-name": "Path 5101",
    d: "M2011.754,894.011c.7-1.624,2.459-2.817,3.845-2.052a1.811,1.811,0,0,1,.889,1.151,1.724,1.724,0,0,1-.267,1.4c-2.853,4.055-.652,17.15-2.709,18.725C2011.177,915.027,2010.482,896.975,2011.754,894.011Z",
    transform: "translate(-1735.595 -122.361)",
    fill: "#d1d8df"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2433",
    "data-name": "Rectangle 2433",
    width: 5.209,
    height: 1.013,
    rx: 0.506,
    transform: "translate(294.506 777.467)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2434",
    "data-name": "Rectangle 2434",
    width: 5.209,
    height: 1.013,
    rx: 0.506,
    transform: "translate(274.828 777.467)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogInMobileFooterIcon);
export default __webpack_public_path__ + "static/media/log-in-mobile-footer-icon.89482250.svg";
export { ForwardRef as ReactComponent };